import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download\"><defs><style></style></defs><path d=\"M213.333 853.333h597.334V768H213.333m597.334-384H640V128H384v256H213.333L512 682.667 810.667 384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol